"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const makeIcon_1 = require("./makeIcon");
const Bank = props => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: '16px', height: '16px', viewBox: '0 0 16 16' }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: 'M8 2L2 4.21138V6.0078H3.33333V11.3359H4.66667V6.0078H7.33333V11.3359H8.66667V6.0078H11.3333V11.3359H12.6667V6.0078H14V5.34179V4.21138L8 2ZM8 3.41919L11.4076 4.67577H4.59245L8 3.41919ZM2 12.668V14H14V12.668H2Z' }, void 0) }), void 0));
exports.BankIcon = (0, makeIcon_1.makeIcon)('bank')(Bank);
//# sourceMappingURL=Bank.js.map